import React, { useState, useEffect, useRef } from "react";
import { Plus, Trash2 } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Playlist = () => {
const navigate = useNavigate();
const { id: slotId } = useParams();

const [searchResults, setSearchResults] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const [selectedItems, setSelectedItems] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
const [offset] = useState(0);
const limit = 2000;
const searchTimeout = useRef(null);

useEffect(() => {
  fetchPlaylist();
  fetchSlot();
}, []);
const fetchSlot = async () => {
  try {
    const res = await apiService.fetchData(`admin/slot/${slotId}`);
    if (!res.error && res.data) {
    }
  } catch (err) {
    toast.error("Error fetching slot.");
  }
};


const fetchPlaylist = async () => {
  try {
    const response = await apiService.postData(`admin/sleep/slot-playlist/${slotId}`, {
      limit,
      offset,
    });

    const rows = Array.isArray(response?.data?.rows) ? response.data.rows : [];

    const preSelected = rows.map((item) => ({
      file_path: item.AudioFile?.file_path || "",
      duration: item.AudioFile?.duration || "",
      sleep_audio_file_id: item.sleep_audio_file_id,
      sleep_playlist_id: item.sleep_playlist_id, // <-- added
      name: item.AudioFile?.name || "",
      isNew: false,
    }));
      
    setSelectedItems(preSelected);
  } catch (error) {
    console.error("Error fetching playlist:", error);
  }
};

const handleSearch = async (query) => {
  if (!query) {
    setSearchResults([]);
    setShowSuggestions(false);
    return;
  }

  try {
    const response = await apiService.postData("admin/sleep/audio-files", {
      file_path: query,
    });

    const data = Array.isArray(response?.data) ? response.data : [];
    setSearchResults(data);
    setShowSuggestions(true);
  } catch (error) {
    console.error("Error searching files:", error);
    setSearchResults([]);
    setShowSuggestions(false);
  }
};

const handleChange = (e) => {
  const { value } = e.target;
  setSearchQuery(value);

  if (searchTimeout.current) clearTimeout(searchTimeout.current);
  searchTimeout.current = setTimeout(() => handleSearch(value), 300);
};

// const handleSelectFile = (file_path, sleep_audio_file_id, name = "") => {
//   const alreadySelected = selectedItems.some(
//     (item) => item.sleep_audio_file_id === sleep_audio_file_id
//   );
//   if (!alreadySelected) {
//     setSelectedItems((prev) => [...prev, { file_path, sleep_audio_file_id, name }]);
//   }
//   setShowSuggestions(false);
//   setSearchQuery("");
// };
const handleSelectFile = async (file_path, sleep_audio_file_id, name = "") => {
  const alreadySelected = selectedItems.some(
    (item) => item.sleep_audio_file_id === sleep_audio_file_id
  );
  if (alreadySelected) {
    toast.warning("This file is already selected.");
    return;
  }

  const newItem = {
    file_path,
    sleep_audio_file_id,
    name,
    isNew: true,
  };

  setSelectedItems((prev) => [...prev, newItem]);
  setShowSuggestions(false);
  setSearchQuery("");

  try {
    await apiService.postData("admin/sleep/slot-playlist", {
      sleep_slot_id: parseInt(slotId),
      playlist: [{ sleep_audio_file_id }],
    });
    toast.success("File added to playlist.");
    fetchPlaylist();
  } catch (error) {
    toast.error("Error adding file to playlist.");
    setSelectedItems((prev) =>
      prev.filter((item) => item.sleep_audio_file_id !== sleep_audio_file_id)
    );
  }
};
    
// const handleRemove = (sleep_audio_file_id) => {
//   setSelectedItems((prev) =>
//     prev.filter((item) => String(item.sleep_audio_file_id) !== String(sleep_audio_file_id))
//   );
// };
const handleRemove = async (sleep_audio_file_id) => {
  const item = selectedItems.find(
    (item) => String(item.sleep_audio_file_id) === String(sleep_audio_file_id)
  );

  if (!item) return;
      toast.info("File removed from playlist.");

  try {
    if (!item.isNew && item.sleep_playlist_id) {
      await apiService.deleteData(`admin/sleep/slot-song/${item.sleep_playlist_id}`);
    }
    setSelectedItems((prev) =>
      prev.filter((i) => String(i.sleep_audio_file_id) !== String(sleep_audio_file_id))
    );
  } catch (error) {
    console.error("Error deleting from backend:", error);
    toast.error("Error removing file.");
  }
};
  
const handleSubmit = async () => {
  try {
    const payload = {
      sleep_slot_id: parseInt(slotId),
      playlist: selectedItems.map((item) => ({
        sleep_audio_file_id: item.sleep_audio_file_id,
      })),
    };

    const response = await apiService.postData("admin/sleep/slot-playlist", payload);
    console.log("Playlist submitted:", response);
    navigate("/radio");
  } catch (error) {
    console.error("Error submitting playlist:", error);
  }
};

return (
  <div className="card">
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4>Playlist</h4>
      <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate(-1)}>
        Back
      </button>
    </div>

    <div className="card-body">
      <div className="form-group position-relative">
        <label>Search File</label>
        <input
          type="text"
          name="file_path"
          className="form-control"
          value={searchQuery}
          onChange={handleChange}
          placeholder="Search any file path"
          autoComplete="off"
        />
        {showSuggestions && (
          <div className="list-group position-absolute w-100 mt-1" style={{ zIndex: 10 }}>
            {searchResults.length > 0 ? (
              searchResults.map((item) => (
                <button
                  type="button"
                  className="list-group-item list-group-item-action"
                  key={item.sleep_audio_file_id}
                  onClick={() =>
                    handleSelectFile(item.file_path, item.sleep_audio_file_id, item.name || "")
                  }
                >
                  {item.file_path}
                </button>
              ))
            ) : (
              <div className="list-group-item text-muted text-center">
                No results found.
              </div>
            )}
          </div>
        )}
      </div>

      {selectedItems.length > 0 && (
        <div className="mt-4">
          <table className="table table-bordered">
            <thead className="table-light">
              <tr>
                <th>Sr No.</th>
                <th>File Path</th>
                <th>Duration in seconds</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {selectedItems.map((item, index) => (
                <tr key={`${item.sleep_audio_file_id}-${index}`}>
                  <td>{index + 1}</td>
                  <td>{item.file_path}</td>
                  <td>{item.duration || '-'}</td>
                                      {/* <td>
                                        {item.file_path ? (
                                          <audio controls className="mt-1">
                                            <source
                                              src={apiService.getAudioUrl(item.file_path)}
                                              type="audio/mp3"
                                            />
                                            Your browser does not support the audio element.
                                          </audio>
                                        ) : (
                                          "No Audio"
                                        )}
                                      </td> */}
                 <td>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleRemove(item.sleep_audio_file_id)}
                    >
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <button className="btn btn-primary mt-3" onClick={handleSubmit}>
            <Plus size={16} className="me-1" />
            Submit Playlist
          </button> */}
        </div>
      )}
    </div>
  </div>
);
};

export default Playlist;